import { Grid, InputAdornment, styled } from "@mui/material";
import React from "react";
import {
  Button,
  Card,
  Form,
  GoBack,
  MenuItem,
  Title,
} from "../../../../components";
import ControlledAutocomplete from "../../../../components/inputs/ControlledAutocomplete";
import {
  ControlledSwitch,
  ControlledTextField,
  CpfCnpjTextField,
  DateTextField,
  PhoneTextField,
  ZipCodeTextField,
} from "../../../../components/inputs";
import { estados } from "../../../../constants/generic.constants";
import Stepper from "../Stepper";
import { HorizontalLoader } from "../../../../components/loaders";
import UpperCaseTextField from "../../../../components/inputs/UpperCaseTextField";
import { InfoOutlined } from "@mui/icons-material";

const Disclaimer = styled(Title)`
  font-family: ${({ theme }) => theme.fonts.family.title};
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0.25rem 0 0 0;
  color: ${({ theme }) => theme.colors.error._500};
`;

const DadosBasicosItauForm = ({
  fluxo,
  tipoPessoa,
  nacionalidades,
  cpfCnpjDisabled,
  handleCpfCnpjChange,
  searching,
  formProps,
  handleSubmit,
  handleZipCodeBlurred,
  submitting,
  principal,
  mesmoEnderecoPrincipal,
  events,
  handleGoTo0,
}) => {
  return (
    <Grid item container justifyContent={"center"} mb={4}>
      <Grid item container spacing={3} maxWidth={704}>
        <GoBack
          handleClick={handleGoTo0}
          text={"Preencha as informações do comprador"}
        />
        <Grid item container alignItems={"center"}>
          <Grid item flex={1}>
            <Stepper current={0} events={events} fluxo={fluxo} />
          </Grid>
        </Grid>
        <Grid item container>
          <Grid item>
            <Card>
              <Form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Title as={"h5"}>Dados pessoais</Title>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <ControlledTextField
                      label={tipoPessoa === "J" ? "CNPJ" : "CPF"}
                      name={"cpfCnpj"}
                      inputProps={{ readOnly: cpfCnpjDisabled }}
                      formProps={formProps}
                      onBlur={handleCpfCnpjChange}
                      type={tipoPessoa === "F" ? "cpf" : "cnpj"}
                      InputProps={{
                        inputComponent: CpfCnpjTextField,
                        endAdornment: !!searching && (
                          <InputAdornment position="end">
                            <HorizontalLoader size={28} />
                          </InputAdornment>
                        ),
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <ControlledTextField
                      label="Nome Completo"
                      name={"nome"}
                      inputProps={{
                        maxLength: 100,
                      }}
                      formProps={formProps}
                      InputProps={{
                        inputComponent: UpperCaseTextField,
                      }}
                    />
                  </Grid>
                  <Grid item container spacing={2}>
                    {tipoPessoa === "F" && (
                      <Grid item xs={12} md={4}>
                        <ControlledTextField
                          name={"dataNascimento"}
                          label={"Data de Nascimento"}
                          formProps={formProps}
                          InputProps={{
                            inputComponent: DateTextField,
                          }}
                        />
                      </Grid>
                    )}
                    <Grid item xs={12} md={8}>
                      <ControlledAutocomplete
                        label="Nacionalidade"
                        domain={nacionalidades}
                        idField={"id"}
                        labelField={"descricao"}
                        name={"nacionalidade"}
                        formProps={formProps}
                        autocompleteProps={{
                          clearText: "Limpar",
                          loadingText: "Carregando opções",
                          noOptionsText: "Nenhuma opção disponível",
                        }}
                      />
                    </Grid>
                  </Grid>
                  <Grid item xs={12}>
                    <Title as={"h5"}>Endereço Residencial</Title>
                  </Grid>
                  {!principal && (
                    <Grid item xs={12}>
                      <ControlledSwitch
                        label="Mora no mesmo endereço do 1º proponente?"
                        name={"mesmoEnderecoPrincipal"}
                        formProps={formProps}
                      />
                    </Grid>
                  )}
                  {!mesmoEnderecoPrincipal && (
                    <>
                      <Grid item xs={12} md={4}>
                        <ControlledTextField
                          label="CEP"
                          name={"endereco.cep"}
                          formProps={formProps}
                          onBlur={handleZipCodeBlurred}
                          InputProps={{
                            inputComponent: ZipCodeTextField,
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} md={8}>
                        <ControlledTextField
                          label="Endereço"
                          name={"endereco.logradouro"}
                          inputProps={{ maxLength: 100 }}
                          formProps={formProps}
                        />
                      </Grid>
                      <Grid item xs={12} md={3}>
                        <ControlledTextField
                          label="Número"
                          name={"endereco.numero"}
                          inputProps={{ maxLength: 7 }}
                          formProps={formProps}
                        />
                      </Grid>
                      <Grid item xs={12} md={4}>
                        <ControlledTextField
                          label="Complemento"
                          name={"endereco.complemento"}
                          inputProps={{ maxLength: 30 }}
                          formProps={formProps}
                        />
                      </Grid>
                      <Grid item xs={12} md={5}>
                        <ControlledTextField
                          label="Bairro"
                          name={"endereco.bairro"}
                          inputProps={{ maxLength: 40 }}
                          formProps={formProps}
                        />
                      </Grid>
                      <Grid item xs={9} md={8}>
                        <ControlledTextField
                          label="Município"
                          name={"endereco.municipio"}
                          inputProps={{ maxLength: 40 }}
                          formProps={formProps}
                        />
                      </Grid>
                      <Grid item xs={3} md={4}>
                        <ControlledTextField
                          label="UF"
                          name={"endereco.uf"}
                          select
                          formProps={formProps}
                        >
                          {estados.map((state) => (
                            <MenuItem key={state} value={state}>
                              {state}
                            </MenuItem>
                          ))}
                        </ControlledTextField>
                      </Grid>
                    </>
                  )}
                  <Grid item xs={12}>
                    <Title as={"h5"}>Informações de contato</Title>
                    <Disclaimer as={"h5"}>
                      <InfoOutlined />
                      Preencher as informações de contato reais de seu cliente
                      aumentam as chances de ele ter o crédito aprovado. Algumas
                      instituições (Inter e C6, no momento) estão reprovando
                      clientes com informações de contato incorretas.
                    </Disclaimer>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <ControlledTextField
                      label="Celular"
                      name="telefone"
                      formProps={formProps}
                      InputProps={{
                        inputComponent: PhoneTextField,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={8}>
                    <ControlledTextField
                      label="E-mail"
                      name="email"
                      formProps={formProps}
                    />
                  </Grid>
                  <Grid item container justifyContent={"center"} mt={1}>
                    <Grid item xs={12} md={4}>
                      <Button type={"submit"} fullWidth loading={submitting}>
                        CONTINUAR
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Form>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default DadosBasicosItauForm;
